const AddSalesRep = () => {

    return (
        <div className=" p-8">
            <div className=" w-full p-8 rounded-lg shadow-lg bg-white border-2 border-slate-300">
                <form action="" className=" w-full">
                    <div className=" flex flex-col sm:flex-row gap-2">
                        <div className=" w-full flex flex-col">
                            <label htmlFor="f-name" className=" text-sm font-semibold">First Name</label>
                            <input type="text" name="first_name" id="f-name" required />
                        </div>
                        <div className=" w-full flex flex-col">
                            <label htmlFor="l-name" className=" text-sm font-semibold">Last Name</label>
                            <input type="text" name="first_name" id="l-name" required />
                        </div>
                    </div>
                    <div className=" flex flex-col sm:flex-row gap-2 my-2">
                        <div className=" w-full flex flex-col">
                            <label htmlFor="staff_id" className=" text-sm font-semibold">Sales Rep Staff ID</label>
                            <input type="text" name="staff_id" id="staff_id" required />
                        </div>
                        <div className=" w-full flex flex-col">
                            <label htmlFor="phone_no" className=" text-sm font-semibold">Phone Number</label>
                            <input type="tel" name="phone_no" id="phone_no" required />
                        </div>
                    </div>
                    <div className=" w-full flex flex-col my-2">
                        <label htmlFor="email" className=" text-sm font-semibold">Email</label>
                        <input type="email" name="email" id="email" required />
                    </div>
                    <div className=" w-full flex flex-col my-2">
                        <label htmlFor="password" className=" text-sm font-semibold">Password</label>
                        <input type="password" name="password" id="password" required />
                    </div>
                    <button className=" w-full bg-tripstore-black text-white" type="submit">Submit</button>
                </form>
            </div>
        </div>
    )
}

export default AddSalesRep